import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import { sumbitManualSkuList } from '../../helper/helper';
import toast from 'react-hot-toast';
//import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CustomButton from '../../components/ui/Button/Button';
import { excelDateToJSDate } from '../../components/ReusableFunctions';

const AccessorySkuModal = ({ modalIsOpen, closeModal, refetch }) => {
  const [manualFile, setManualFile] = useState([]);
  const [alertMessage, setAlertMessage] = useState(null);

  const validateFile = (excelData) => {
    const errors = {
      fileErrors: [],
      columnErrors: [],
      dataErrors: [],
    };

    // File validation
    // const fileNamePattern = /^sku_\d{8}\.xlsx$/;
    // if (!fileNamePattern.test(file.name)) {
    //   errors.fileErrors.push('Invalid file name. Must match "sku_YYYYMMDD.xlsx".');
    // }
    // if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    //   errors.fileErrors.push('Invalid file type. Only .xlsx files are allowed.');
    // }

    // Column structure validation
    const requiredHeaders = ['SKU', 'Accessory Name', 'COST', 'MSRP',"Date Created"];
    const headers = excelData[0];
    const errorMessage = 'Invalid column headers.';
    const errorColumn = 'Extra columns are not allowed.';
    if (
      !requiredHeaders.every(
        (header, index) => header.toLowerCase() === headers[index].toLowerCase(),
      )
    ) {
      // errors.columnErrors.push('Invalid column headers or order.');
      errors.columnErrors.push(errorMessage);
      // Remove the error after 5 seconds
      setTimeout(() => {
        const index = errors.columnErrors.indexOf(errorMessage);
        if (index !== -1) {
          errors.columnErrors.splice(index, 1);
        }
      }, 200);
    }
    if (headers.length !== requiredHeaders.length) {
      errors.columnErrors.push(errorColumn);
      setTimeout(() => {
        const index = errors.columnErrors.indexOf(errorColumn);
        if (index !== -1) {
          errors.columnErrors.splice(index, 1);
        }
      }, 200);
    }

    // Data validation
    const stores = excelData.slice(1);

    // If we want to apply maximum rows
    // const maxRows = 1000;
    // if (stores.length > maxRows) {
    //   errors.dataErrors.push(`File exceeds maximum row limit of ${maxRows}.`);
    // }

    const skuSet = new Set();
    stores.forEach((row, index) => {
      if (row?.length === 0) {
        // return if row is empty
        return;
      }
      const [sku, name, cost, msrp, created_at] = row;
      if (!sku || !name || !cost || !msrp || !created_at) {
        errors.dataErrors.push(`Row ${index + 2}: Contains null values or 0.`);
      }
      if (skuSet.has(sku)) {
        errors.dataErrors.push(`Row ${index + 2}: Duplicate SKU "${sku}".`);
      }
      skuSet.add(sku);
      if (parseFloat(cost) <= 0 || parseFloat(msrp) <= 0) {
        errors.dataErrors.push(`Row ${index + 2}: COST and MSRP must be greater than 0.`);
      }
      if (parseFloat(msrp) < parseFloat(cost)) {
        errors.dataErrors.push(`Row ${index + 2}: MSRP must be greater than or equal to COST.`);
      }
    });

    return errors;
  };

  const handleFileUpload = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    const reader = new FileReader();
    if (!file) return;
    
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      let excelData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
       excelData = excelData.map(row => {
        const [sku, name, cost, msrp, created_at] = row;
        const formattedDate = typeof created_at === 'number' ? excelDateToJSDate(created_at) : created_at;
        return [sku, name, cost, msrp, formattedDate];
      });

      const errors = validateFile(excelData);
      if (errors.fileErrors.length > 0) {
        setAlertMessage((prev)=>[prev, ...errors.columnErrors]);
        return;
      }
      if (errors.columnErrors.length > 0) {
        setAlertMessage((prev)=>[prev, ...errors.columnErrors]);
        return;
      }
      if (errors.dataErrors.length > 0) {
        setAlertMessage(errors.dataErrors);
        return;
      }
      const stores = excelData.slice(1);
      setManualFile(stores);
    };
    reader.readAsArrayBuffer(file);
  };

  const onSubmit = (event) => {
    event.preventDefault();
    if (manualFile.length > 0) {
      let promise = sumbitManualSkuList({ manualFile: manualFile.map(([SKU, name, cost, MSRP,date]) => ({ sku:SKU, name, cost: parseFloat(cost), msrp: parseFloat(MSRP),created_at:date })) });
     promise.then(()=>{refetch();closeModal()})
      toast.promise(promise, {
        loading: 'Submitting...',
        success: <b>Submitted Successfully...!</b>,
        error: <b>Could not Submit.</b>,
      });
    } else {
      toast.error('Please upload a file!');
    }
  };

  useEffect(() => {
    return () => {
      setAlertMessage(null);
    };
  }, []);
  return (
    modalIsOpen && (
      <div className="hi-modal">
        <div className="modal-content">
          <div className="close-button">
            <button onClick={closeModal}>✖</button>
          </div>
          <div className="top">
            {/* for Home internet upload */}
            <div className="block">
              <div className="top-block">
                <h4>Accessory SKU file</h4>
                <span>Select one file at a time.</span>
              </div>
              <div className="bottom-block">
                <input
                  onChange={handleFileUpload}
                  multiple={false}
                  type="file"
                  id="cis"
                  name="cis"
                />
              </div>
            </div>
          </div>
          <div className="bottom">
            {/*   <button onClick={onSubmit} className="sub-btn" type="submit">
              Upload
            </button>*/}

            {/* disable it unless file  is validated*/}
            <CustomButton
              btnLabel="Upload"
              buttonType='success'
              onClick={onSubmit}
              type="submit"
                />
              </div>

          {alertMessage && (
            <div className="alert-message">
              {alertMessage?.map((msg, index) => (
                <p key={index}>{msg}</p>
              ))}
            </div>
          )}
        </div>
      </div>
    )
  );
};
export default AccessorySkuModal;
